<template>
  <div style="height: 100%">
    <div class="button" :class="{ 'disabled': disabled }" @click="open()">
      <font-awesome-icon :icon="['fas', 'ellipsis-v']" style="height: 100%; width: 0.6em;"/>
    </div>
    <div v-if="show">
      <!-- the backdrop is an invisible layer outside of the dropdown that will close the dropdown if it is clicked on  -->
      <div class="dropdown-backdrop" @click="close()"/>
      <slot name="dropdown"/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'PromptItemOverflow',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    open() {
      this.show = true;
      this.$emit('opened');
    },
    close() {
      this.show = false;
      this.$emit('closed');
    }
  },
})
</script>

<style scoped lang="scss">

.dropdown-backdrop {
  position: fixed;
  cursor: default;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 3;
}

.button {
  display: flex;
  justify-content: center;
  height: 100%;
  width: 2%;
  text-align: center;
  cursor: pointer;
}

.disabled {
  pointer-events: none;
}

</style>
